import { jsx as a } from "react/jsx-runtime";
import { c as u } from "../../../clsx-OuTLNxxd.js";
import { useState as b } from "react";
const f = "_stepper_1qhw1_29", k = "_dot_1qhw1_34", v = "_active_1qhw1_44", w = "_clickable_1qhw1_47", r = {
  stepper: f,
  dot: k,
  active: v,
  clickable: w
}, D = ({
  stepsCount: p,
  onStepChange: n,
  currentStep: l,
  initialStep: _ = 0,
  isClickable: s = !1
}) => {
  const [i, m] = b(_), S = l ?? i, c = (t) => t === S, o = (t) => {
    s && !c(t) && (m(t), n?.(t));
  };
  return /* @__PURE__ */ a("div", { className: r.stepper, children: Array.from({ length: p }).map((t, e) => /* @__PURE__ */ a(
    "button",
    {
      className: u(r.dot, c(e) && r.active, s && r.clickable),
      onClick: () => o(e),
      tabIndex: 0,
      onKeyDown: (h) => h.key === "Enter" && o(e),
      "aria-pressed": c(e),
      "aria-label": `Step ${e + 1}`
    },
    e
  )) });
};
export {
  D as StepperDots
};
